import React from 'react';
import ServiceTemplate from '@/components/ServiceTemplate';

const RenovationPartielle = () => {
  return (
    <ServiceTemplate
      title="Rénovation Partielle"
      heroImage="https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1600"
      description="Modernisation ciblée pour un rafraîchissement rapide et efficace de votre salle de bains."
      priceRange="8’000 - 18’000 CHF"
      duration="1-3 semaines"
      features={[
        'Remplacement de la douche ou baignoire',
        'Changement des meubles et vasques',
        'Modernisation du carrelage (partiel)',
        'Remplacement des robinetteries',
        'Amélioration de l\'éclairage',
        'Conservation de certains éléments existants'
      ]}
      includes={[
        {
          title: 'Douche/Baignoire',
          description: 'Remplacement et installation d\'une nouvelle douche ou baignoire moderne'
        },
        {
          title: 'Meubles & Vasques',
          description: 'Installation de nouveaux meubles et vasques contemporains'
        },
        {
          title: 'Robinetterie',
          description: 'Remplacement de tous les robinets par des modèles modernes'
        },
        {
          title: 'Éclairage',
          description: 'Amélioration de l\'éclairage avec de nouveaux luminaires'
        },
        {
          title: 'Carrelage ciblé',
          description: 'Remplacement partiel ou complément du carrelage existant'
        },
        {
          title: 'Peinture',
          description: 'Rafraîchissement des surfaces peintes'
        }
      ]}
      benefits={[
        'Coût inférieur à une rénovation complète',
        'Délai de réalisation plus court',
        'Modernisation efficace sans tout démolir',
        'Conservation des éléments en bon état',
        'Impact visuel immédiat et valorisant',
        'Solution idéale pour un budget maîtrisé'
      ]}
    />
  );
};

export default RenovationPartielle;